"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _EmptyList = _interopRequireDefault(require("../../screens/Settings/components/EmptyList"));
var _default = exports["default"] = function _default() {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_EmptyList["default"], {
    image: t('no-results.png'),
    title: "",
    subtitle: /*#__PURE__*/_react["default"].createElement("div", {
      className: "mt-4"
    }, t('contacts.search.empty.title'))
  });
};
//# sourceMappingURL=index.js.map